import { Box, BoxProps } from '@chakra-ui/react';

export const MAIN_CONTENT_ID = 'main-content';

type LayoutMainProps = BoxProps & {
  asMain?: boolean;
};

export const LayoutMain = ({
  children,
  id,
  asMain = true,
  tabIndex,
  ...rest
}: LayoutMainProps) => {
  const resolvedId = id ?? (asMain ? MAIN_CONTENT_ID : undefined);
  const resolvedTabIndex = tabIndex ?? (asMain ? -1 : undefined);

  return (
    <Box
      as={asMain ? 'main' : 'div'}
      id={resolvedId}
      tabIndex={resolvedTabIndex}
      order={2}
      background='chakra-body-bg'
      p={6}
      flexGrow={1}
      flexShrink={1}
      overflow='auto'
      {...rest}
    >
      {children}
    </Box>
  );
};
